import { vuexHandbook } from '@/store/composition/handbook'
import { ProductTypeApi } from '@/api/handbook/ProductType/ProductTypeApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: ProductTypeApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
